import { render, staticRenderFns } from "./Votepage.vue?vue&type=template&id=ab57c742&scoped=true&"
import script from "./Votepage.vue?vue&type=script&lang=ts&"
export * from "./Votepage.vue?vue&type=script&lang=ts&"
import style0 from "./Votepage.vue?vue&type=style&index=0&id=ab57c742&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab57c742",
  null
  
)

export default component.exports